import React from "react";
import "./PremiumLockedPanel.css";

const TAB_COPY = {
  "my-students": {
    title: "My Students is a Premium Feature",
    description:
      "Unlock My Students to view and manage your matched student pipeline with powerful recruiter tools.",
  },
  international: {
    title: "International Student Query is a Premium Feature",
    description:
      "Unlock International access to reach and engage international student opportunities.",
  },
  "premium-service": {
    title: "Premium Service Campaign is Locked",
    description:
      "Create and run digital campaigns to promote your college and connect with the right students.",
  },
  banner: {
    title: "Banner Management is a Premium Feature",
    description:
      "Upload and manage campaign banners to strengthen your brand presence across the platform.",
  },
};

const PremiumLockedPanel = ({ tabKey = "premium-service" }) => {
  const copy = TAB_COPY[tabKey] || TAB_COPY["premium-service"];

  return (
    <div className="premium-locked-panel">
      <div className="premium-locked-card">
        <div className="premium-locked-badge" aria-hidden="true">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10V8a5 5 0 0 1 10 0v2"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <rect
              x="5"
              y="10"
              width="14"
              height="10"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="12" cy="15" r="1.5" fill="currentColor" />
          </svg>
        </div>

        <p className="premium-locked-eyebrow">Premium Access Required</p>
        <h2 className="premium-locked-title">{copy.title}</h2>
        <p className="premium-locked-desc">{copy.description}</p>

        <div className="premium-locked-benefits">
          <div className="premium-locked-benefit">
            <span className="premium-locked-dot" />
            Priority student matching
          </div>
          <div className="premium-locked-benefit">
            <span className="premium-locked-dot" />
            Campaign &amp; banner tools
          </div>
          <div className="premium-locked-benefit">
            <span className="premium-locked-dot" />
            Full recruiter insights
          </div>
        </div>

        <div className="premium-locked-cta">
          <p className="premium-locked-cta-text">
            Contact your <strong>Admin</strong> to upgrade to{" "}
            <strong>Premium</strong> and unlock this tab.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PremiumLockedPanel;
